module.exports = __webpack_public_path__ + "static/media/logo.f51bdc06.png";